import { BorrowSection } from "@/components/home/BorrowSection";
import { MOTOKO_DOLLAR_LOGO, PLATFORM_NAME } from "@/lib/routes";

/** Action-focused borrow — multi-collateral deposit → mint Motoko Dollar. */
export default function BorrowPage() {
	return (
		<div className="container mx-auto max-w-5xl space-y-6 px-4 py-6 sm:py-8">
			<div className="flex items-start gap-3">
				<img
					src={MOTOKO_DOLLAR_LOGO}
					alt=""
					className="mt-0.5 h-11 w-11 shrink-0 object-contain sm:h-12 sm:w-12"
				/>
				<div className="min-w-0">
					<p className="section-eyebrow">Borrow</p>
					<h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
						Mint Motoko Dollar
					</h1>
					<p className="mt-1 max-w-xl text-sm text-muted-foreground">
						Deposit ICP, ckBTC, or ckETH, then mint {PLATFORM_NAME} (USDM).
						Liquidation collateralization ratio is 1.50×. Writes need Internet
						Identity.
					</p>
				</div>
			</div>
			<BorrowSection />
		</div>
	);
}
